import { renderAppGridOverlay } from 'Bomdisoft/shared/top-bar/render';

/** The product switcher's behaviour: the button toggles the overlay, and a press outside it or a pick inside it closes it. */
export const delegateAppGrid = (document: Document) => {
  const wrap = document.querySelector<HTMLElement>('.landing-app-grid-wrap');
  const button = wrap?.querySelector<HTMLButtonElement>('.landing-app-grid-button');
  if (!wrap || !button) return;
  const close = () => {
    wrap.querySelector('.landing-app-grid-overlay')?.remove();
    button.setAttribute('aria-expanded', 'false');
  };
  const open = () => {
    wrap.insertAdjacentHTML('beforeend', renderAppGridOverlay().value);
    button.setAttribute('aria-expanded', 'true');
  };
  button.addEventListener('click', () => (button.getAttribute('aria-expanded') === 'true' ? close() : open()));
  wrap.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('.landing-app-grid-overlay-item')) close();
  });
  document.addEventListener('mousedown', event => {
    if (!(event.target instanceof Node) || !wrap.contains(event.target)) close();
  });
};
